import {isArray} from "lodash-es";
import {Tooltip} from "antd";
import React from "react";

export const config = {
  rowSelection: false,
  pagination: false,
  fieldControl: false,
  tableType: 'antd',
  search: [
    {
      label: '适用门店',
      name: 'shopId',
      itemType: 'select',
      key: 'id',
      labelKey: 'companyName',
      data: 'companyList',
      allowClear: false,
    },
    {
      label: '配置项名称',
      name: 'dtlNameLike',
    },
    {
      label: '类型',
      name: 'busType',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'busTypeList',
    },
  ],
  columns: [
    {
      title: '配置项名称',
      dataIndex: ['dtlName'],
      width: 220,
      render: 'titleRender',
    },
    {
      title: '类型',
      dataIndex: ['busTypeName'],
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产品类型',
      dataIndex: ['productSku','prodTypeName'],
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '来源',
      width: 120,
      dataIndex: ['productSku','sourceTypeName'],
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'SKU_ID',
      width: 160,
      dataIndex: ['productSku','id'],
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'SKU适用门店',
      dataIndex: ['productSku'],
      render: (_, record: Record<string, any>)=>{
        const shopList = isArray(record?.productSku?.shops)?record?.productSku?.shops:[];
        const txt = shopList?.map(item => item.companyName).join(',');
        return <Tooltip title={txt||""}  placement="topLeft">
          <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',width:190}}>{txt||""}</div>
        </Tooltip>
      },
      width: 200,
    },
    {
      title: 'SKU状态',
      dataIndex: ['productSku'],
      width: 100,
      render: 'enableRender',
      fixed: 'right',
    },
    {
      title: '操作',
      dataIndex: 'actionRender',
      render: 'actionRender',
      fixed: 'right',
      width: 100,
    },
  ],
}
